<template>
  <wrapper-page pageTitle="Projects Dashboard">
    <ProjectKpis
      v-if="projectDashboardKpis"
      :projectKpis="projectDashboardKpis"
    />

    <div
      class="card-header bg-white d-flex justify-content-between align-items-center py-3 cursor-pointer"
      style="cursor: pointer"
      @click="isOpen = !isOpen"
    >
      <h6 class="m-0 font-weight-bold text-primary">Projects by department</h6>
      <button
        type="button"
        class="btn btn-sm btn-link text-decoration-none p-0"
      >
        <i
          class="fas"
          :class="isOpen ? 'fa-chevron-up' : 'fa-chevron-down'"
        ></i>
      </button>
    </div>
    <div v-if="projectDashboardKpis && isOpen" class="row">
      <chart-card :value="chartData" size="col-lg-6 col-md-12"></chart-card>
    </div>

    <ProjectsPeriodReportCard />
  </wrapper-page>
</template>

<script>
import { getProjectDashboardKpis } from "@/apis/kpis";
import WrapperPage from "../../components/layout/WrapperPage.vue";
import ProjectKpis from "../../components/projects/ProjectKpis.vue";
import ChartCard from "@/components/ui/ChartCard.vue";
import ProjectsPeriodReportCard from "../../components/projects/ProjectsPeriodReportCard.vue";

export default {
  name: "ProjectsDashboard",
  components: {
    ChartCard,
    WrapperPage,
    ProjectKpis,
    ProjectsPeriodReportCard,
  },
  data() {
    return {
      projectDashboardKpis: null,
      loading: false,
      isOpen: false,
    };
  },
  computed: {
    chartData() {
      if (!this.projectDashboardKpis) return [];

      return Object.keys(this.projectDashboardKpis).reduce(
        (accumulator, key) => {
          if (
            key === "totalProjects" ||
            key === "projectsAssigned" ||
            key === "projectsClosed"
          ) {
            return accumulator;
          }
          return [
            ...accumulator,
            {
              type: this.fieldNameMapper(key),
              number: this.projectDashboardKpis[key],
            },
          ];
        },
        []
      );
    },
  },
  methods: {
    fieldNameMapper(key) {
      const fieldnames = {
        totalProjects: "TOTAL",
        departmentDna: "D&NA",
        departmentSscs: "SS&CS",
        departmentNsm: "NSM",
        departmentOt: "OT",
        departmentMess: "ME&SS",
        departmentRdi: "RD&I",
        departmentConsultancy: "Consultancy",
        departmentAdministration: "Administration",
      };
      return fieldnames[key] || key;
    },

    async fetchDashboardData() {
      this.loading = true;
      try {
        const response = await getProjectDashboardKpis();
        this.projectDashboardKpis = response?.data;
      } catch (error) {
        console.error("Failed to fetch dashboard KPIs:", error);
      } finally {
        this.loading = false;
      }
    },
  },
  mounted() {
    this.fetchDashboardData();
  },
};
</script>
